<mat-list-item class="favorite-drivers-list-item" lines="0">
  <img id="favoriteDriverListItem-image-driverProfileImage-{{ driver.id }}" matListItemIcon class="avatar" [dotsDriver]="dotsDriver" />
  <h4 id="favoriteDriverListItem-text-favoriteDriverFullName-{{ driver.id }}" matListItemTitle data-private>
    {{ driver.firstName }} {{ driver.lastName }}
  </h4>
  <div matListItemMeta>
    <button
      id="favoriteDriverListItem-button-removeDriver-{{ driver.id }}"
      mat-stroked-button
      color="warn"
      (click)="deleteFavoriteDriver()"
    >
      <mat-icon>remove_circle</mat-icon>&nbsp;
      <span data-private>Remove {{ driver.firstName }}</span>
    </button>
  </div>
</mat-list-item>
